import React from "react";
import PropTypes from "prop-types";
import { formatUpcomingPafDate } from "../../utils/dashboardAppraisalSummary";

const UpcomingPefs = ({ items = [], today }) => (
  <section className="dashboard-panel upcoming-pefs" aria-labelledby="upcoming-pafs-title">
    <header className="dashboard-panel__header">
      <h2 id="upcoming-pafs-title">Upcoming Published PAF&apos;s</h2>
    </header>
    <div className="upcoming-pefs__list">
      {items.length === 0 ? (
        <div className="upcoming-pefs__empty">No upcoming PAF events</div>
      ) : (
        items.map((item) => (
          <div className="upcoming-pefs__row" key={item.id}>
            <span>{item.title}</span>
            <span>{item.due || formatUpcomingPafDate(item.date, today)}</span>
            <span>{item.cycle || item.frequency || item.designation || ""}</span>
          </div>
        ))
      )}
    </div>
  </section>
);

UpcomingPefs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      due: PropTypes.string,
      date: PropTypes.string,
      cycle: PropTypes.string,
      frequency: PropTypes.string,
      designation: PropTypes.string,
    })
  ),
  today: PropTypes.string,
};

export default UpcomingPefs;
